import type React from "react";

const Flow: React.FC = () => {
	const steps = [
		{
			id: "signup",
			number: 1,
			title: "会員登録",
			description: "簡単な情報入力で無料会員登録",
			icon: "📝",
		},
		{
			id: "select-interest",
			number: 2,
			title: "興味分野の選択",
			description: "学びたい分野・テーマを選択",
			icon: "🎯",
		},
		{
			id: "join-event",
			number: 3,
			title: "イベント参加",
			description: "もくもく会や勉強会に参加",
			icon: "👥",
		},
		{
			id: "continue-learning",
			number: 4,
			title: "継続的な学習",
			description: "仲間と一緒に成長を続ける",
			icon: "🌱",
		},
	];

	return (
		<section className="py-16 md:py-24 bg-gray-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center mb-12">
					<h2 className="text-3xl md:text-4xl font-bold mb-4">
						参加までの流れ
					</h2>
					<p className="text-lg text-gray-600">
						4つのステップで簡単に始められます
					</p>
				</div>

				<div className="grid md:grid-cols-4 gap-8">
					{steps.map((step) => (
						<div key={step.id} className="relative text-center">
							<div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-3xl">
								{step.icon}
							</div>
							<div className="bg-white p-6 rounded-lg shadow-md">
								<div className="text-blue-600 font-bold mb-2">
									STEP {step.number}
								</div>
								<h3 className="text-xl font-semibold mb-2">{step.title}</h3>
								<p className="text-gray-600">{step.description}</p>
							</div>
							{step.id !== steps[steps.length - 1].id && (
								<div className="hidden md:block absolute top-1/4 left-full w-8 h-8 transform -translate-y-1/2">
									<svg
										className="w-full h-full text-gray-300"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
										aria-hidden="true"
										role="img"
									>
										<title>次のステップを示す矢印</title>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M9 5l7 7-7 7"
										/>
									</svg>
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Flow;
